import { StyledTitle } from './title.styles';

export default StyledTitle;
